export default __webpack_public_path__ + "static/media/pngBlank.f7a9f9f4.png";